import React from 'react';
import BookManagComponent from '../../components/BookManagComponent/BookManagComponent';

function BookManagementPage() {
  return <BookManagComponent />;
}

export default BookManagementPage;
